export default __webpack_public_path__ + "locales/fi/JavascriptSdk.json?hash=e1d571a71a458987b0e27a63ccaed09c";